import { useTranslation } from "react-i18next"
import React, {ReactNode} from "react";

import { Delete as DeleteIcon } from '@vedmarket/ui-kit';
import { ButtonProps } from '@mui/material';
import Typography from "@mui/material/Typography";
import Button from '@mui/material/Button'

import './modalSmall.scss'

import ModalBig from "../modalBig";

type Props = {
    onContinue: (index?: number | string) => void,
    onClose: () => void;
    isOpen: boolean,
    index?: number | string,
    title: string,
    description: ReactNode
    customButton?: ReactNode
    customWidth?: number
    noPadding?: boolean
    buttonYesText: string,
}

const ModalAction = ({
  onContinue,
  isOpen,
  index,
  onClose,
  title,
  description,
  buttonYesText
}: Props) => {

  const { t } = useTranslation()

  const handleClickYes = () => index ? onContinue(index) : onContinue()

  return (
    <ModalBig
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      width={736}
      buttons={<div className='modal-common__actions'>
        <Button
          variant='outlined'
          sx={{ minWidth: '238px', marginRight: 3}}
          onClick={onClose}
        >{t('actions__text__cancel')}</Button>

        <Button
          variant='contained'
          onClick={handleClickYes}
          color='error'
          startIcon={<DeleteIcon />}
          fullWidth
        >{buttonYesText}</Button>
      </div>}
    >
      <Typography variant='body1' className='modal-common__description'>{description}</Typography>
    </ModalBig>
  )
}

export default ModalAction
